<template>
  <div>
    <div class="types">
      <h2>Types</h2>
      <h3 class="mt-font--body20">Error</h3>
      <mt-noti-banner
        type="error" title="Notification title"
        subTitle="Subtitle" actionLabel="Action" />

      <h3 class="mt-font--body20">Warning</h3>
      <mt-noti-banner
        title="Notification title" subTitle="Subtitle"
        actionLabel="Action" />

      <h3 class="mt-font--body20">Success</h3>
      <mt-noti-banner
        type="success" title="Notification title"
        subTitle="Subtitle" actionLabel="Action" />

      <h3 class="mt-font--body20">Information</h3>
      <mt-noti-banner
        type="info" title="Notification title"
        subTitle="Subtitle" actionLabel="Action" />
    </div><!--//.types-->

    <div class="styles">
      <h2>Style</h2>
      <h3 class="mt-font--body20 colors">Colors</h3>
      <div class="left height250 mt--bg--neutrals-light-gray-01">
        <div class="caption">Error</div>
        <mt-noti-banner
          type="error" title="Notification title"
          subTitle="Subtitle" actionLabel="Action" />
      </div>
      <div class="right mt-font--body10">
        <p>Background: #FEF2F0</p>
        <p>Button background: #FDD9D7</p>
        <p>Border: #F44336</p>
        <p>icon: #F44336,   #485464  opacity 80%</p>
        <p>Text: #485464</p>
      </div>
      <div class="mt--clearfix"></div>
      <div class="left height250 mt--bg--neutrals-light-gray-01">
        <div class="caption">Warning</div>
        <mt-noti-banner
          title="Notification title"
          subTitle="Subtitle" actionLabel="Action" />
      </div>
      <div class="right mt-font--body10">
        <p>Background: #FFFAED</p>
        <p>Button background: #FFF3CD</p>
        <p>Border: #FFC107</p>
        <p>icon: #FFC107,   #485464  opacity 80%</p>
        <p>Text: #485464</p>
      </div>
      <div class="mt--clearfix"></div>
      <div class="left height250 mt--bg--neutrals-light-gray-01">
        <div class="caption">Success</div>
        <mt-noti-banner
          type="success" title="Notification title"
          subTitle="Subtitle" actionLabel="Action" />
      </div>
      <div class="right mt-font--body10">
        <p>Background: #EDFAF3</p>
        <p>Button background: #CCF4DC</p>
        <p>Border: #00C853</p>
        <p>icon: #00C853,   #485464  opacity 80%</p>
        <p>Text: #485464</p>
      </div>
      <div class="mt--clearfix"></div>
      <div class="left height250 mt--bg--neutrals-light-gray-01">
        <div class="caption">Infomation</div>
        <mt-noti-banner
          type="info" title="Notification title"
          subTitle="Subtitle" actionLabel="Action" />
      </div>
      <div class="right mt-font--body10">
        <p>Background: #F5F4FF</p>
        <p>Button background: #E3E0FF</p>
        <p>Border: #7364FF</p>
        <p>icon: #7364FF,   #485464  opacity 80%</p>
        <p>Text: #485464</p>
      </div>
      <div class="mt--clearfix"></div>

      <h3 class="mt-font--body20 sizing">Sizing</h3>
      <div class="left imgbox mt--bg--neutrals-light-gray-01">
        <img :src="sizing" />
      </div>
      <div class="right mt-font--body10">
        <p>Width: auto</p>
        <p>Height: 42px</p>
        <p>border: 1px</p>
        <p>Font size: 14px</p>
        <p>Line height: 22px</p>
      </div>
      <div class="mt--clearfix"></div>
      <div class="left imgbox mt--bg--neutrals-light-gray-01">
        <img :src="sizingButton" />
      </div>
      <div class="right mt-font--body10">
        <p>Button heigth: 26px</p>
        <p>Font size: 14px </p>
        <p>Line height: 22px</p>
      </div>
    </div><!--//.styles-->
  </div>
</template>

<script>
export default {
  name: 'notificationBanner',
  props: [],
  components: {

  },
  data () {
    return {
      sizing: require('@/assets/notification-banner-sizing@3x.png'),
      sizingButton: require('@/assets/notification-banner-button-sizing@3x.png'),
    }
  },
  computed: {

  },

  methods: {

  },
}
</script>
<style lang="scss" scoped>
h3 { font-weight: normal; }
h3.sizing { margin-top: 110px}
h3.sizing, h3.colors { margin-bottom:27px}
p {
  line-height: 1.57;
  margin: 0;
}
.types .mt-noti-banner {
  width: 600px;
  float: right;
  margin-bottom: 39px;
}
.styles .mt-noti-banner {
  margin: 0 auto;
  width: 78%;
}
.right {
  width: 270px;
  padding: 2%;
  float: left;
  height: 94px;
  .button-wrap{
    padding-right: 20px;
  }
}
.left{
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  width: 600px;
  float: left;
  position: relative;
  margin-bottom: 2em;
  &.height250 { height: 250px; }
  &.imgbox {
    display: block;
    img { width: 100%; }
  }
  .caption {
    position: absolute;
    left: 15px;
    top: 15px;
  }
  .button-wrap + .button-wrap {
    margin-top: 1.5em;
  }
}
.tabs .tabs-banners {
  cursor: pointer;
  width: 63px;
  height: 22px;
  font-size: 16px;
  color: #485465;
}
.tabs .tabs-flags {
  cursor: pointer;
  width: 111px;
  height: 22px;
  font-size: 16px;
  color: #485465;
  padding-left: 49px;
}
.tabs .tabs-inlines {
  cursor: pointer;
  width: 112px;
  height: 22px;
  font-size: 16px;
  color: #485465;
  padding-left: 47px;
}
</style>



// WEBPACK FOOTER //
// NotificationBanner.vue?2d2851de